import { BaseModel, ModelInstance, ToFrontHook, ToBackHook } from './util';
import { TeamUser } from './team-user';

@ModelInstance({
  mappingFields: {
    id: 'id',
    tournament_team_invite_id: 'tournamentTeamInviteId',
    tournament_team_id: 'tournamentTeamId',
    team_user: 'teamUser',
    accepted: 'accepted'
  },
  relation: {
    teamUser: TeamUser
  }
})
export class TournamentTeamUserInvite extends BaseModel {
  id: number;
  tournamentTeamInviteId: number;
  tournamentTeamId: number;
  teamUser: TeamUser;
  accepted: boolean;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
